import { AppBranding } from "@/config/branding";
import { Link } from "@tanstack/react-router";

interface PublicHeaderProps {
  activePage?: "home" | "login" | "privacypolicy";
}

export function PublicHeader({ activePage }: PublicHeaderProps) {
  const linkClass = (page: PublicHeaderProps["activePage"]) =>
    `text-sm font-medium transition-colors ${
      activePage === page
        ? "text-primary-600 border-b-2 border-primary-600 pb-0.5"
        : "text-gray-500 hover:text-gray-800"
    }`;

  return (
    <header className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5">
          <img
            src="/icon/app_icon.png"
            alt={`${AppBranding.name} Logo`}
            className="h-12 w-12 rounded-lg object-cover"
          />
          <span className="text-xl font-bold text-gray-900">{AppBranding.name}</span>
          <span className="hidden md:inline ml-2 body-sm text-gray-500">{AppBranding.tagline}</span>
        </Link>

        {/* Nav links */}
        <nav className="flex items-center gap-6">
          <Link to="/" className={linkClass("home")}>
            Home
          </Link>
          <Link to="/login" className={linkClass("login")}>
            Login
          </Link>
        </nav>
      </div>
    </header>
  );
}
